__turbopack_context__.v({
  "nav-content-dropdown-link": "NavbarMenuLink-module__JYiTAq__nav-content-dropdown-link",
  "nav-content-menu-arrow-link": "NavbarMenuLink-module__JYiTAq__nav-content-menu-arrow-link",
  "nav-content-menu-link": "NavbarMenuLink-module__JYiTAq__nav-content-menu-link",
});
